import { AlertTriangle, FileText, ShoppingBag } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const UseCases = () => {
  const { t } = useTranslation();

  const cases = [
    {
      icon: <AlertTriangle className="h-12 w-12 text-yellow-500" />,
      title: t('landing.useCases.dataBreaches.title'),
      description: t('landing.useCases.dataBreaches.description')
    },
    {
      icon: <FileText className="h-12 w-12 text-blue-600" />,
      title: t('landing.useCases.newsletters.title'),
      description: t('landing.useCases.newsletters.description')
    },
    {
      icon: <ShoppingBag className="h-12 w-12 text-green-600" />,
      title: t('landing.useCases.shopping.title'),
      description: t('landing.useCases.shopping.description')
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('landing.useCases.title')}
          </h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            {t('landing.useCases.subtitle')}
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {cases.map((useCase, index) => (
            <div 
              key={index} 
              className="flex flex-col p-6 rounded-xl bg-white shadow-md hover:shadow-lg transition-shadow"
            >
              <div className="mb-4">{useCase.icon}</div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{useCase.title}</h3>
              <p className="text-gray-700">{useCase.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UseCases;